import {Component, OnInit} from '@angular/core';
import {SeoService} from '../../../services/seo.service';
import {NavigationEnd, Router} from '@angular/router';
import {Store} from '../../../store';
import {Title} from '@angular/platform-browser';
import {CmsService} from '../../../services/cms.service';
import {filter} from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
    selector: 'app-bespoke-form-page',
    templateUrl: './bespoke-form-page.component.html',
    styleUrls: ['./bespoke-form-page.component.scss']
})
export class BespokeFormPageComponent implements OnInit {
    page;
    routerObserver;
    contentLoaded$ = new BehaviorSubject<boolean>(false);

    constructor(
        private store: Store,
        public router: Router,
        private titleService: Title,
        private seoService: SeoService,
        private cmsService: CmsService,
        private overlayService : OverlayService
    ) {
        this.overlayService.addLoadingSubject(this.contentLoaded$);
        this.routerObserver = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            const activeRoute = event.url.replace(/^\/|\/$/g, '');
            this.getPages(activeRoute);
        });
    }

    ngOnInit(): void {
    }

    getPages(route) {
        this.cmsService.pages().subscribe((data) => {
            const pages = this.store.selectForLocal('pages');
            this.contentLoaded$.next(true);
            if (pages) {
                this.page = pages[route];
                if (this.page) {
                    this.titleService.setTitle(this.page.metaTitle);
                    this.setMetaTags(this.page);
                }
            }
        });
    }

    setMetaTags(data) {
        this.seoService.updateTitle(data.metaTitle);
        this.seoService.addMetaTag('description', data.metaDescription);
        this.seoService.createLinkForCanonicalURL();
    }

}
